<template>
  <div class="popup" @click.self="close()">
    <div class="popup__wrapper">
      <div class="popup__hdr">
        <span class="popup__ttl">{{ title }}</span>
        <ButtonClose class="popup__close" @click="close()"/>
      </div>
      <p class="popup__description">{{ description }}</p>
      <ButtonMain :type="'secondary'" @click="action()">Оформить подписку</ButtonMain>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, onMounted, onBeforeUnmount } from 'vue';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
  //----------------
  import ButtonSocial from '@shared/UI/Buttons/ButtonSocial/ButtonSocial.vue';
  import ButtonClose from '@shared/UI/Buttons/ButtonClose/ButtonClose.vue';
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //----------------
  const store = useStore();
  //----------------
  onMounted(() => {
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.telegramSubscribePopup)
  });
  onBeforeUnmount(() => {
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.telegramSubscribePopup);
  });
  //----------------
  const title = computed(() => 'Покупка подписки');
  const description = computed(() => 'Перейдите в Cryptocloud для оформления подписки');
  //----------------
  const close = () => {
    store.commit('UserSystem/SET_TELEGRAM_SUBSCRIBE_WIDGET_LAST', false);
  }

  const action = () => {
    const url = sessionStorage.getItem('telegramWidgetCurrentLinks');
    window.open(url, '_blank');
  }

</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>